export class Assurance
{
    id:number;
    active:boolean;
    code: String;
    label:String;
}